module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "product-overlay"
  }, [_c('nav', {
    staticClass: "nav is-hidden-tablet",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "nav__mobile-header"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--close"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "home-link",
    attrs: {
      "title": "Home",
      "to": {
        name: 'Intro'
      }
    }
  }, [_c('logo')], 1)], 1)]), _vm._v(" "), (_vm.product) ? _c('div', {
    staticClass: "inner"
  }, [_c('header', {
    staticClass: "mobile-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.product.title))])]), _vm._v(" "), _c('section', {
    staticClass: "section left"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "slideshow-outer"
  }, [_c('slideshow', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slideshowVisible),
      expression: "slideshowVisible"
    }],
    attrs: {
      "images": _vm.product.images
    },
    on: {
      "imgsloaded": function($event) {
        _vm.slideshowVisible = true
      }
    }
  }), _vm._v(" "), (!_vm.slideshowVisible && _vm.preloadImg) ? _c('img', {
    staticClass: "preload-img",
    attrs: {
      "src": _vm.preloadImg
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "section right h7 nimbus-sans"
  }, [_c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slideshowVisible || _vm.preloadImg),
      expression: "slideshowVisible || preloadImg"
    }],
    staticClass: "description-title title-case"
  }, [_vm._v(_vm._s(_vm.product.title))]), _vm._v(" "), _c('section', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.descriptionHtml + _vm.priceHTML)
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "actions"
  }, [(_vm.cart) ? [_c('li', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addToCart.apply(null, arguments)
      }
    }
  }, [_vm._v("ADD "), (!_vm.cartItem) ? _c('span', [_vm._v("TO CART")]) : _vm._e()]), _vm._v(" "), (_vm.cartItem) ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCartItem(-1)
      }
    }
  }, [_vm._v("DEDUCT")]) : _vm._e()]), _vm._v(" "), (_vm.cartTotalCount > 0) ? _c('li', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clear.apply(null, arguments)
      }
    }
  }, [_vm._v("CLEAR")]), _vm._v(" "), _c('a', {
    staticClass: "checkout-btn",
    attrs: {
      "href": _vm.cart.webUrl
    }
  }, [_vm._v("CHECKOUT "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.cartTotalCount))])])]) : _vm._e()] : [_vm._m(0)]], 2)])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close h9 icon-close-overlay",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close-mobile ui-nw-icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "mailto:info@dovedaledesignstudio.com"
    }
  }, [_vm._v("ENQUIRE")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02e4549d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CollectionItem.vue
// module id = 370
// module chunks = 1